import { inject } from '@angular/core';
import type { ResolveFn } from '@angular/router';
import type { Observable } from 'rxjs';
import type { ImportProgress } from '../../../common/interfaces/import-progress';
import type { FleetImportData } from '../constants/fleet-import-schema';
import { FleetService } from '../services/fleet.service';

export const importFleetResolver: ResolveFn<
  (data: FleetImportData[]) => Observable<ImportProgress>
> = () => {
  const fleetService = inject(FleetService);
  return (data) => fleetService.importFleet(data);
};
